export const createLoginProcessSlice = (set) => ({
  authIsProcessed: false,
  authProcessStarted: false,
  setAuthIsProcessed: (authIsProcessed) => set({ authIsProcessed }),
  setAuthProcessStarted: (authProcessStarted) => set({ authProcessStarted }),
  resetLoginProcess: () => set({ authIsProcessed: false, authProcessStarted: false })
});
